"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.splitPromoCode = void 0;
const splitPromoCode = promoCode => {
  const parts = promoCode.split('-');
  if (parts.length === 3 && parts[0]?.length === 2) {
    return {
      referral: `${parts[0]}-${parts[1]}`,
      voucher: parts[2]
    };
  }
  return {
    referral: promoCode,
    voucher: undefined
  };
};
exports.splitPromoCode = splitPromoCode;